<template>
   <div>
      <div v-for="newrow in news" :key="news.indexOf(newrow)">
         <v-alert v-if="newrow!=null" :type="newrow.err_type" dismissible outlined text class="mb-4">
            <span v-html="formatText('<strong>'+newrow.new_subject+' :</strong>\n'+newrow.new_body)"></span>
         </v-alert>
      </div> 
   </div> 
</template>

<script>
export default {
   props: {
      news: Array
   },

   methods: {
      formatText: function(string) {
         var ret = string.replace(/\n/g,'<br/>');
         return ret;
      }
   },

   data: () => {
      return {}
   }
}
</script>